<script lang="ts">
	import { resolve } from '$app/paths';
	import ArrowIcon from '$lib/components/marketing/redesign2025/ArrowIcon.svelte';
	import PageHero from '$lib/components/marketing/redesign2025/PageHero.svelte';
	import { m } from '$lib/paraglide/messages.js';
	import { getLocale, localizeHref } from '@/paraglide/runtime';

	const locale = $derived(getLocale());

	const features = $derived.by(() => {
		void locale;
		return [
			{
				n: '01',
				title: m.l6_feat1_title(),
				body: m.l6_feat1_body()
			},
			{
				n: '02',
				title: m.l6_feat2_title(),
				body: m.l6_feat2_body()
			},
			{
				n: '03',
				title: m.l6_feat3_title(),
				body: m.l6_feat3_body()
			}
		];
	});
</script>

<PageHero
	eyebrow={m.l6_hero_eyebrow()}
	breadcrumbLabel={m.l6_hero_breadcrumb()}
	lead={m.l6_hero_lead()}
>
	{#snippet heroImage(className)}
		<enhanced:img
			src="/static/img/landing/redesign-2025/photos/heeling-city.avif"
			alt=""
			class={className}
			fetchpriority="high"
			sizes="100vw"
		></enhanced:img>
	{/snippet}
	{m.l6_hero_h1_before()}<em class="italic">{m.l6_hero_h1_em()}</em>
</PageHero>

<section class="py-20 md:py-[100px]">
	<div class="mx-auto max-w-[1240px] px-5 md:px-10">
		<div class="grid items-start gap-9 lg:grid-cols-[0.9fr_1.1fr] lg:gap-[70px]">
			<div>
				<span
					class="mb-5 block text-[0.72rem] font-semibold tracking-[0.22em] text-zp-muted uppercase"
					>{m.l6_intro_eyebrow()}</span
				>
				<h2 class="text-[clamp(1.9rem,3.4vw,3rem)] leading-[1.06]">
					{m.l6_intro_h2()}
				</h2>
			</div>
			<div>
				<p class="mb-5 text-[1.1rem] text-zp-prose">
					{m.l6_intro_p1_before()}<b class="text-zp-ink">{m.l6_commission_rate()}</b
					>{m.l6_intro_p1_after()}
				</p>
				<p class="mb-0 text-[1.1rem] text-zp-prose">
					{m.l6_intro_p2()}
				</p>
				<a
					href={resolve(localizeHref('/anadir-barco'))}
					class="mt-6 inline-flex items-center gap-2 rounded-md border border-transparent bg-zp-navy px-6 py-3.5 text-[0.86rem] font-semibold text-zp-paper transition-all hover:-translate-y-px hover:bg-zp-ink"
				>
					{m.landing_cta_register()}
					<ArrowIcon />
				</a>
			</div>
		</div>
	</div>
</section>

<section class="bg-zp-paper2 py-20 md:py-[100px]">
	<div class="mx-auto max-w-[1240px] px-5 md:px-10">
		<div class="grid gap-7 md:grid-cols-3">
			{#each features as f (f.n)}
				<div class="rounded-2xl border border-zp-line bg-white px-8 py-[34px]">
					<div class="mb-8 font-serif text-[1.05rem] text-zp-accent">{f.n}</div>
					<h3 class="mb-3 text-[1.3rem] leading-snug">{f.title}</h3>
					<p class="m-0 text-[0.98rem] text-zp-muted">{f.body}</p>
				</div>
			{/each}
		</div>
	</div>
</section>

<section
	class="zp-cta-band"
	style="background-image: url('/img/landing/redesign-2025/photos/regata-vigo.avif')"
>
	<div
		class="relative z-[2] mx-auto max-w-[1240px] px-5 py-24 text-zp-paper md:px-10 md:py-[120px]"
	>
		<h2 class="mb-5 max-w-[16ch] text-[clamp(2rem,4vw,3.4rem)] leading-[1.05] text-white">
			{m.l6_cta_h2()}
		</h2>
		<p class="mb-8 max-w-[46ch] text-[1.12rem] text-zp-paper/85">
			{m.l6_cta_p()}
		</p>
		<a
			href={resolve(localizeHref('/anadir-barco'))}
			class="inline-flex items-center gap-2 rounded-[40px] border border-transparent bg-zp-paper px-6 py-3.5 text-[0.86rem] font-semibold text-zp-navy transition-all hover:-translate-y-px hover:bg-white"
		>
			{m.l6_cta_btn()}
			<ArrowIcon />
		</a>
	</div>
</section>
